function generateRandomId(length = 10) {
	const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	let result = '';
	for (let i = 0; i < length; i++) {
		result += characters.charAt(Math.floor(Math.random() * characters.length));
	}
	return result;
}

/**
 * initAccordions
 */
function initAccordions() {
	const accordions = document.querySelectorAll('.wp-block-zp4-accordions');

	accordions.forEach(accordion => {
		const isMultiselect = accordion.dataset.accordionsMultiselect === 'true';
		const toggles = accordion.querySelectorAll('.accordion-toggle');

		toggles.forEach(toggle => {
			const uniqueId = generateRandomId();
			const headerId = `accordion-header-${uniqueId}`;
			const panelId = `accordion-panel-${uniqueId}`;

			toggle.id = headerId;
			toggle.nextElementSibling.id = panelId;

			toggle.onclick = function () {
				const isActive = toggle.classList.contains('is-active');

				if (!isMultiselect && !isActive) {
					// Close all other panels in the same accordion
					const otherToggles = accordion.querySelectorAll('.accordion-toggle.is-active');
					otherToggles.forEach(otherToggle => {
						otherToggle.classList.remove('is-active');
						otherToggle.nextElementSibling.classList.remove('is-active');
						otherToggle.setAttribute('aria-expanded', 'false');
					});
				}

				// Toggle the current panel
				toggle.classList.toggle('is-active');
				toggle.nextElementSibling.classList.toggle('is-active');
				toggle.setAttribute('aria-expanded', isActive ? 'false' : 'true');
			};
		});
	});
}

window.addEventListener(
	'load',
	function () {
		initAccordions();
	},
	false
);
